<template>
    <div class="col-md-8">
        <form v-if="status == 'input'" @submit="submit">
            <h4>Your details</h4>
            <div class="field text required form-group">
                <input type="text" name="Name" v-model="applicant.Name" placeholder="Name" required />
            </div>
            <!-- <div class="field text required form-group">
                <input type="text" name="Address" v-model="applicant.Address" required placeholder="Address" />
            </div>
            <div class="field text required form-group">
                <input type="text" name="Address2" v-model="applicant.Address2" required placeholder="Address" />
            </div>
            <div class="field text required form-group">
                <input type="text" name="Address3" v-model="applicant.Address3" placeholder="Address" />
            </div> 
            <div class="field text required form-group">
                <input type="number" name="Postcode" v-model="applicant.Postcode" required placeholder="Postcode" />
            </div>-->
            <div class="field text required form-group">
                <input type="email" name="Email" v-model="applicant.Email" required placeholder="Email" />
            </div>
            <div class="field text required form-group">
                <input type="text" name="Phone" v-model="applicant.Phone" required placeholder="Phone" />
            </div>

            <h4>What dates and times will you be available?</h4>
            <div class="field textarea required form-group">
                <textarea type="text" required name="Availability" v-model="applicant.Availability"></textarea>
            </div>

            <h4>Names and ages of people in your group</h4>
            <h5>Max 5 people total (please note: anyone 14 and older will be asked to fill in the survey)</h5>
            <div class="field textarea required form-group">

                <textarea type="text" required name="NamesAndAges" v-model="applicant.NamesAndAges"></textarea>
            </div>

            <div class="field text form-group">
                <input type="text" name="HowHeard" v-model="applicant.HowHeard" required placeholder="How did you learn about the mystery visitor survey?" />
            </div>

            <div class="Actions">
                <button type="submit"  value="">Submit application</button>
            </div>
        </form>
        <div v-else-if="status == 'submitting'">
            Submitting....
        </div>
        <div v-else-if="status == 'thanks'">
            <h4>Thanks for submitting your application</h4>

            <p>We will be in touch soon.</p>
        </div>
        <div v-else>
            <h4>Error</h4>

            <p>Something has gone wrong. Please try again later.</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'App',
        data() {
            return {
                error: '',
                status: 'input',
                applicant: {
                    'Name': null,
                    'Address': null,
                    'Address2': null,
                    'Address3': null,
                    'Postcode': null,
                    'Email': null,
                    'Phone': null,
                    'Availability': null,
                    'NamesAndAges': null,
                    'HowHeard': null
                }
            }
        },
        methods: {
            submit(e) {
                this.status = 'submitting';
                e.preventDefault();

                axios.post(window.location.href + '/submit', this.applicant).then((result) => {
                   
                    if (result.data.status == 'OK') {
                        this.status = 'thanks';
                    } else {
                        this.status = 'error';
                    }
                });
            }
        },
        components: {

        }
    }
</script>

<style>
   
</style>
